const normalizeSlug = (value) =>
  String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');

export const resolveAccountIdFromSlug = (slug) => `acc_${normalizeSlug(slug)}`;

export const resolveAccountBasePath = (slug) => `accounts/${resolveAccountIdFromSlug(slug)}`;

export const resolveAccountCollectionPath = (slug, collectionPath = '') => {
  const base = resolveAccountBasePath(slug);
  const suffix = String(collectionPath || '').replace(/^\/+/, '');
  return suffix ? `${base}/${suffix}` : base;
};

export const resolveAccountStoragePath = (slug, storagePath = '') => {
  const base = resolveAccountBasePath(slug);
  const suffix = String(storagePath || '').replace(/^\/+/, '');
  return suffix ? `${base}/${suffix}` : base;
};
